// source: legebill/site/postexpectation/v4/post_expectation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_type_date_pb = require('../../../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var legebill_type_workday_pb = require('../../../../legebill/type/workday_pb.js');
goog.object.extend(proto, legebill_type_workday_pb);
var google_type_dayofweek_pb = require('../../../../google/type/dayofweek_pb.js');
goog.object.extend(proto, google_type_dayofweek_pb);
var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.AddToMemberListRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.AddToMemberListResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.CreateLeaveRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.DayExpectation', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.DeleteLeaveRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.IntervalDuration', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.Leave', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.LeaveAmount', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ListLeavesRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ListLeavesResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.MemberCustomWorkdays', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.MemberExpectation', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.MemberList', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.PostExpectation', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.PostExpectation.RemindHoursType', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.PostExpectation.UserListTypeCase', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse', null, global);
goog.exportSymbol('proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.PostExpectation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.PostExpectation.repeatedFields_, proto.legebill.site.post_expectation.v4.PostExpectation.oneofGroups_);
};
goog.inherits(proto.legebill.site.post_expectation.v4.PostExpectation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.PostExpectation.displayName = 'proto.legebill.site.post_expectation.v4.PostExpectation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.MemberList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.MemberList.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.MemberList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.MemberList.displayName = 'proto.legebill.site.post_expectation.v4.MemberList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.IntervalDuration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.IntervalDuration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.IntervalDuration.displayName = 'proto.legebill.site.post_expectation.v4.IntervalDuration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.displayName = 'proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.displayName = 'proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.AddToMemberListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.AddToMemberListRequest.displayName = 'proto.legebill.site.post_expectation.v4.AddToMemberListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.AddToMemberListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.AddToMemberListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.AddToMemberListResponse.displayName = 'proto.legebill.site.post_expectation.v4.AddToMemberListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.displayName = 'proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.displayName = 'proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.displayName = 'proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.displayName = 'proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.displayName = 'proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.displayName = 'proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.displayName = 'proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.displayName = 'proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.displayName = 'proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.displayName = 'proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.displayName = 'proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.displayName = 'proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.displayName = 'proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.displayName = 'proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.MemberCustomWorkdays, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.displayName = 'proto.legebill.site.post_expectation.v4.MemberCustomWorkdays';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.Leave = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.Leave, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.Leave.displayName = 'proto.legebill.site.post_expectation.v4.Leave';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.displayName = 'proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.displayName = 'proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.MemberExpectation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.MemberExpectation.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.MemberExpectation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.MemberExpectation.displayName = 'proto.legebill.site.post_expectation.v4.MemberExpectation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.DayExpectation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.DayExpectation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.DayExpectation.displayName = 'proto.legebill.site.post_expectation.v4.DayExpectation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.CreateLeaveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.CreateLeaveRequest.displayName = 'proto.legebill.site.post_expectation.v4.CreateLeaveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ListLeavesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ListLeavesRequest.displayName = 'proto.legebill.site.post_expectation.v4.ListLeavesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.post_expectation.v4.ListLeavesResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.ListLeavesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.ListLeavesResponse.displayName = 'proto.legebill.site.post_expectation.v4.ListLeavesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.DeleteLeaveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.displayName = 'proto.legebill.site.post_expectation.v4.DeleteLeaveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.displayName = 'proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.displayName = 'proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.PostExpectation.repeatedFields_ = [9,13];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.legebill.site.post_expectation.v4.PostExpectation.oneofGroups_ = [[7,8]];

/**
 * @enum {number}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.UserListTypeCase = {
  USER_LIST_TYPE_NOT_SET: 0,
  USER_INCLUDE_LIST: 7,
  USER_EXCLUDE_LIST: 8
};

/**
 * @return {proto.legebill.site.post_expectation.v4.PostExpectation.UserListTypeCase}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getUserListTypeCase = function() {
  return /** @type {proto.legebill.site.post_expectation.v4.PostExpectation.UserListTypeCase} */(jspb.Message.computeOneofCase(this, proto.legebill.site.post_expectation.v4.PostExpectation.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.PostExpectation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.PostExpectation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.PostExpectation.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    label: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ianaTzName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    startLocalDateTime: jspb.Message.getFieldWithDefault(msg, 5, ""),
    intervalDuration: (f = msg.getIntervalDuration()) && proto.legebill.site.post_expectation.v4.IntervalDuration.toObject(includeInstance, f),
    userIncludeList: (f = msg.getUserIncludeList()) && proto.legebill.site.post_expectation.v4.MemberList.toObject(includeInstance, f),
    userExcludeList: (f = msg.getUserExcludeList()) && proto.legebill.site.post_expectation.v4.MemberList.toObject(includeInstance, f),
    summaryRecipientMembershipIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    standardWorkdaysList: jspb.Message.toObjectList(msg.getStandardWorkdaysList(),
    legebill_type_workday_pb.Workday.toObject, includeInstance),
    remindUserHours: jspb.Message.getFieldWithDefault(msg, 11, 0),
    remindHoursType: jspb.Message.getFieldWithDefault(msg, 14, 0),
    sendSummariesHours: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.PostExpectation;
  return proto.legebill.site.post_expectation.v4.PostExpectation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.PostExpectation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIanaTzName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartLocalDateTime(value);
      break;
    case 6:
      var value = new proto.legebill.site.post_expectation.v4.IntervalDuration;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.IntervalDuration.deserializeBinaryFromReader);
      msg.setIntervalDuration(value);
      break;
    case 7:
      var value = new proto.legebill.site.post_expectation.v4.MemberList;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.MemberList.deserializeBinaryFromReader);
      msg.setUserIncludeList(value);
      break;
    case 8:
      var value = new proto.legebill.site.post_expectation.v4.MemberList;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.MemberList.deserializeBinaryFromReader);
      msg.setUserExcludeList(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addSummaryRecipientMembershipIds(value);
      break;
    case 13:
      var value = new legebill_type_workday_pb.Workday;
      reader.readMessage(value,legebill_type_workday_pb.Workday.deserializeBinaryFromReader);
      msg.addStandardWorkdays(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRemindUserHours(value);
      break;
    case 14:
      var value = /** @type {!proto.legebill.site.post_expectation.v4.PostExpectation.RemindHoursType} */ (reader.readEnum());
      msg.setRemindHoursType(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSendSummariesHours(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.PostExpectation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.PostExpectation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.PostExpectation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIanaTzName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStartLocalDateTime();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIntervalDuration();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.legebill.site.post_expectation.v4.IntervalDuration.serializeBinaryToWriter
    );
  }
  f = message.getUserIncludeList();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.legebill.site.post_expectation.v4.MemberList.serializeBinaryToWriter
    );
  }
  f = message.getUserExcludeList();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.legebill.site.post_expectation.v4.MemberList.serializeBinaryToWriter
    );
  }
  f = message.getSummaryRecipientMembershipIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getStandardWorkdaysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      legebill_type_workday_pb.Workday.serializeBinaryToWriter
    );
  }
  f = message.getRemindUserHours();
  if (f !== 0) {
    writer.writeUint64(
      11,
      f
    );
  }
  f = message.getRemindHoursType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSendSummariesHours();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.RemindHoursType = {
  REMIND_HOURS_TYPE_UNSPECIFIED: 0,
  REMIND_BEFORE: 1,
  REMIND_AFTER: 2
};

/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string iana_tz_name = 4;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getIanaTzName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setIanaTzName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string start_local_date_time = 5;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getStartLocalDateTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setStartLocalDateTime = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional IntervalDuration interval_duration = 6;
 * @return {?proto.legebill.site.post_expectation.v4.IntervalDuration}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getIntervalDuration = function() {
  return /** @type{?proto.legebill.site.post_expectation.v4.IntervalDuration} */ (
    jspb.Message.getWrapperField(this, proto.legebill.site.post_expectation.v4.IntervalDuration, 6));
};


/**
 * @param {?proto.legebill.site.post_expectation.v4.IntervalDuration|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
*/
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setIntervalDuration = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.clearIntervalDuration = function() {
  return this.setIntervalDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.hasIntervalDuration = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional MemberList user_include_list = 7;
 * @return {?proto.legebill.site.post_expectation.v4.MemberList}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getUserIncludeList = function() {
  return /** @type{?proto.legebill.site.post_expectation.v4.MemberList} */ (
    jspb.Message.getWrapperField(this, proto.legebill.site.post_expectation.v4.MemberList, 7));
};


/**
 * @param {?proto.legebill.site.post_expectation.v4.MemberList|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
*/
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setUserIncludeList = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.legebill.site.post_expectation.v4.PostExpectation.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.clearUserIncludeList = function() {
  return this.setUserIncludeList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.hasUserIncludeList = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional MemberList user_exclude_list = 8;
 * @return {?proto.legebill.site.post_expectation.v4.MemberList}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getUserExcludeList = function() {
  return /** @type{?proto.legebill.site.post_expectation.v4.MemberList} */ (
    jspb.Message.getWrapperField(this, proto.legebill.site.post_expectation.v4.MemberList, 8));
};


/**
 * @param {?proto.legebill.site.post_expectation.v4.MemberList|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
*/
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setUserExcludeList = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.legebill.site.post_expectation.v4.PostExpectation.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.clearUserExcludeList = function() {
  return this.setUserExcludeList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.hasUserExcludeList = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated string summary_recipient_membership_ids = 9;
 * @return {!Array<string>}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getSummaryRecipientMembershipIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setSummaryRecipientMembershipIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.addSummaryRecipientMembershipIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.clearSummaryRecipientMembershipIdsList = function() {
  return this.setSummaryRecipientMembershipIdsList([]);
};


/**
 * repeated legebill.type.Workday standard_workdays = 13;
 * @return {!Array<!proto.legebill.type.Workday>}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getStandardWorkdaysList = function() {
  return /** @type{!Array<!proto.legebill.type.Workday>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_workday_pb.Workday, 13));
};


/**
 * @param {!Array<!proto.legebill.type.Workday>} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
*/
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setStandardWorkdaysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.legebill.type.Workday=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Workday}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.addStandardWorkdays = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.legebill.type.Workday, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.clearStandardWorkdaysList = function() {
  return this.setStandardWorkdaysList([]);
};


/**
 * optional uint64 remind_user_hours = 11;
 * @return {number}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getRemindUserHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setRemindUserHours = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional RemindHoursType remind_hours_type = 14;
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation.RemindHoursType}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getRemindHoursType = function() {
  return /** @type {!proto.legebill.site.post_expectation.v4.PostExpectation.RemindHoursType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.PostExpectation.RemindHoursType} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setRemindHoursType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional uint64 send_summaries_hours = 12;
 * @return {number}
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.getSendSummariesHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.PostExpectation.prototype.setSendSummariesHours = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.MemberList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.MemberList.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.MemberList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.MemberList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.MemberList.toObject = function(includeInstance, msg) {
  var f, obj = {
    membershipIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.MemberList}
 */
proto.legebill.site.post_expectation.v4.MemberList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.MemberList;
  return proto.legebill.site.post_expectation.v4.MemberList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.MemberList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.MemberList}
 */
proto.legebill.site.post_expectation.v4.MemberList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addMembershipIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.MemberList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.MemberList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.MemberList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.MemberList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string membership_ids = 1;
 * @return {!Array<string>}
 */
proto.legebill.site.post_expectation.v4.MemberList.prototype.getMembershipIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.legebill.site.post_expectation.v4.MemberList} returns this
 */
proto.legebill.site.post_expectation.v4.MemberList.prototype.setMembershipIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.post_expectation.v4.MemberList} returns this
 */
proto.legebill.site.post_expectation.v4.MemberList.prototype.addMembershipIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.MemberList} returns this
 */
proto.legebill.site.post_expectation.v4.MemberList.prototype.clearMembershipIdsList = function() {
  return this.setMembershipIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.IntervalDuration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.IntervalDuration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.toObject = function(includeInstance, msg) {
  var f, obj = {
    units: jspb.Message.getFieldWithDefault(msg, 1, 0),
    unitType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.IntervalDuration}
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.IntervalDuration;
  return proto.legebill.site.post_expectation.v4.IntervalDuration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.IntervalDuration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.IntervalDuration}
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnits(value);
      break;
    case 2:
      var value = /** @type {!proto.legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType} */ (reader.readEnum());
      msg.setUnitType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.IntervalDuration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.IntervalDuration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnits();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getUnitType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType = {
  INTERVAL_UNSPECIFIED: 0,
  WEEKS: 1,
  MONTHS: 2
};

/**
 * optional uint32 units = 1;
 * @return {number}
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.prototype.getUnits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.post_expectation.v4.IntervalDuration} returns this
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.prototype.setUnits = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional IntervalUnitType unit_type = 2;
 * @return {!proto.legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType}
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.prototype.getUnitType = function() {
  return /** @type {!proto.legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType} value
 * @return {!proto.legebill.site.post_expectation.v4.IntervalDuration} returns this
 */
proto.legebill.site.post_expectation.v4.IntervalDuration.prototype.setUnitType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    postExpectation: (f = msg.getPostExpectation()) && proto.legebill.site.post_expectation.v4.PostExpectation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest}
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest;
  return proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest}
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.legebill.site.post_expectation.v4.PostExpectation;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.PostExpectation.deserializeBinaryFromReader);
      msg.setPostExpectation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPostExpectation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.legebill.site.post_expectation.v4.PostExpectation.serializeBinaryToWriter
    );
  }
};


/**
 * optional PostExpectation post_expectation = 1;
 * @return {?proto.legebill.site.post_expectation.v4.PostExpectation}
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.prototype.getPostExpectation = function() {
  return /** @type{?proto.legebill.site.post_expectation.v4.PostExpectation} */ (
    jspb.Message.getWrapperField(this, proto.legebill.site.post_expectation.v4.PostExpectation, 1));
};


/**
 * @param {?proto.legebill.site.post_expectation.v4.PostExpectation|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest} returns this
*/
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.prototype.setPostExpectation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest} returns this
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.prototype.clearPostExpectation = function() {
  return this.setPostExpectation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.CreatePostExpectationRequest.prototype.hasPostExpectation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    postExpectationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    memberListType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest}
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest;
  return proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest}
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostExpectationId(value);
      break;
    case 3:
      var value = /** @type {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType} */ (reader.readEnum());
      msg.setMemberListType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPostExpectationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMemberListType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType = {
  MEMBER_LIST_UNION_TYPE_UNSPECIFIED: 0,
  ALL_MEMBERS: 1,
  INCLUDE_MEMBERS: 2,
  EXCLUDE_MEMBERS: 3
};

/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string post_expectation_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.prototype.getPostExpectationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.prototype.setPostExpectationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional MemberListType member_list_type = 3;
 * @return {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType}
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.prototype.getMemberListType = function() {
  return /** @type {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType} value
 * @return {!proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.prototype.setMemberListType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.AddToMemberListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.AddToMemberListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    postExpectationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    memberId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.AddToMemberListRequest}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.AddToMemberListRequest;
  return proto.legebill.site.post_expectation.v4.AddToMemberListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.AddToMemberListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.AddToMemberListRequest}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostExpectationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.AddToMemberListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.AddToMemberListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPostExpectationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMemberId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.AddToMemberListRequest} returns this
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string post_expectation_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.prototype.getPostExpectationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.AddToMemberListRequest} returns this
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.prototype.setPostExpectationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string member_id = 3;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.prototype.getMemberId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.AddToMemberListRequest} returns this
 */
proto.legebill.site.post_expectation.v4.AddToMemberListRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.AddToMemberListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.AddToMemberListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.AddToMemberListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.AddToMemberListResponse}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.AddToMemberListResponse;
  return proto.legebill.site.post_expectation.v4.AddToMemberListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.AddToMemberListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.AddToMemberListResponse}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.AddToMemberListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.AddToMemberListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.AddToMemberListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.AddToMemberListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    postExpectationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    memberId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest;
  return proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostExpectationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPostExpectationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMemberId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest} returns this
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string post_expectation_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.prototype.getPostExpectationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest} returns this
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.prototype.setPostExpectationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string member_id = 3;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.prototype.getMemberId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest} returns this
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse;
  return proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.RemoveFromMemberListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest;
  return proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    postExpectationsList: jspb.Message.toObjectList(msg.getPostExpectationsList(),
    proto.legebill.site.post_expectation.v4.PostExpectation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse;
  return proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.legebill.site.post_expectation.v4.PostExpectation;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.PostExpectation.deserializeBinaryFromReader);
      msg.addPostExpectations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPostExpectationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.legebill.site.post_expectation.v4.PostExpectation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PostExpectation post_expectations = 1;
 * @return {!Array<!proto.legebill.site.post_expectation.v4.PostExpectation>}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.prototype.getPostExpectationsList = function() {
  return /** @type{!Array<!proto.legebill.site.post_expectation.v4.PostExpectation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.post_expectation.v4.PostExpectation, 1));
};


/**
 * @param {!Array<!proto.legebill.site.post_expectation.v4.PostExpectation>} value
 * @return {!proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse} returns this
*/
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.prototype.setPostExpectationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.PostExpectation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.post_expectation.v4.PostExpectation}
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.prototype.addPostExpectations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.site.post_expectation.v4.PostExpectation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse} returns this
 */
proto.legebill.site.post_expectation.v4.ListPostExpectationsResponse.prototype.clearPostExpectationsList = function() {
  return this.setPostExpectationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    postExpectationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    summaryRecipientMembershipId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest;
  return proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostExpectationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummaryRecipientMembershipId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPostExpectationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSummaryRecipientMembershipId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest} returns this
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string post_expectation_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.prototype.getPostExpectationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest} returns this
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.prototype.setPostExpectationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string summary_recipient_membership_id = 3;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.prototype.getSummaryRecipientMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest} returns this
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientRequest.prototype.setSummaryRecipientMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse;
  return proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.AddSummaryRecipientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    postExpectationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    summaryRecipientMembershipId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest;
  return proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostExpectationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummaryRecipientMembershipId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPostExpectationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSummaryRecipientMembershipId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest} returns this
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string post_expectation_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.prototype.getPostExpectationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest} returns this
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.prototype.setPostExpectationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string summary_recipient_membership_id = 3;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.prototype.getSummaryRecipientMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest} returns this
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.prototype.setSummaryRecipientMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse;
  return proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest}
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest;
  return proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest}
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ArchivePostExpectationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    postExpectationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    workday: (f = msg.getWorkday()) && legebill_type_workday_pb.Workday.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest}
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest;
  return proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest}
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostExpectationId(value);
      break;
    case 3:
      var value = new legebill_type_workday_pb.Workday;
      reader.readMessage(value,legebill_type_workday_pb.Workday.deserializeBinaryFromReader);
      msg.setWorkday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPostExpectationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkday();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      legebill_type_workday_pb.Workday.serializeBinaryToWriter
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest} returns this
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string post_expectation_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.getPostExpectationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest} returns this
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.setPostExpectationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional legebill.type.Workday workday = 3;
 * @return {?proto.legebill.type.Workday}
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.getWorkday = function() {
  return /** @type{?proto.legebill.type.Workday} */ (
    jspb.Message.getWrapperField(this, legebill_type_workday_pb.Workday, 3));
};


/**
 * @param {?proto.legebill.type.Workday|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest} returns this
*/
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.setWorkday = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest} returns this
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.clearWorkday = function() {
  return this.setWorkday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.SetStandardWorkdayRequest.prototype.hasWorkday = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    membershipId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    workday: (f = msg.getWorkday()) && legebill_type_workday_pb.Workday.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest}
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest;
  return proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest}
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 3:
      var value = new legebill_type_workday_pb.Workday;
      reader.readMessage(value,legebill_type_workday_pb.Workday.deserializeBinaryFromReader);
      msg.setWorkday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkday();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      legebill_type_workday_pb.Workday.serializeBinaryToWriter
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest} returns this
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string membership_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest} returns this
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional legebill.type.Workday workday = 3;
 * @return {?proto.legebill.type.Workday}
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.getWorkday = function() {
  return /** @type{?proto.legebill.type.Workday} */ (
    jspb.Message.getWrapperField(this, legebill_type_workday_pb.Workday, 3));
};


/**
 * @param {?proto.legebill.type.Workday|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest} returns this
*/
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.setWorkday = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest} returns this
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.clearWorkday = function() {
  return this.setWorkday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.SetCustomWorkdayRequest.prototype.hasWorkday = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    membershipId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    daysOfWeekList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest}
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest;
  return proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest}
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 3:
      var values = /** @type {!Array<!proto.google.type.DayOfWeek>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDaysOfWeek(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDaysOfWeekList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest} returns this
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string membership_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest} returns this
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated google.type.DayOfWeek days_of_week = 3;
 * @return {!Array<!proto.google.type.DayOfWeek>}
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.getDaysOfWeekList = function() {
  return /** @type {!Array<!proto.google.type.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.google.type.DayOfWeek>} value
 * @return {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest} returns this
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.setDaysOfWeekList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.google.type.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest} returns this
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.addDaysOfWeek = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest} returns this
 */
proto.legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.prototype.clearDaysOfWeekList = function() {
  return this.setDaysOfWeekList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest;
  return proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    memberCustomWorkdaysList: jspb.Message.toObjectList(msg.getMemberCustomWorkdaysList(),
    proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse;
  return proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.legebill.site.post_expectation.v4.MemberCustomWorkdays;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.deserializeBinaryFromReader);
      msg.addMemberCustomWorkdays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberCustomWorkdaysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MemberCustomWorkdays member_custom_workdays = 2;
 * @return {!Array<!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays>}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.prototype.getMemberCustomWorkdaysList = function() {
  return /** @type{!Array<!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.post_expectation.v4.MemberCustomWorkdays, 2));
};


/**
 * @param {!Array<!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays>} value
 * @return {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse} returns this
*/
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.prototype.setMemberCustomWorkdaysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays}
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.prototype.addMemberCustomWorkdays = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.legebill.site.post_expectation.v4.MemberCustomWorkdays, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse} returns this
 */
proto.legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.prototype.clearMemberCustomWorkdaysList = function() {
  return this.setMemberCustomWorkdaysList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.toObject = function(includeInstance, msg) {
  var f, obj = {
    membershipId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    customWorkdaysList: jspb.Message.toObjectList(msg.getCustomWorkdaysList(),
    legebill_type_workday_pb.Workday.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays}
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.MemberCustomWorkdays;
  return proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays}
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 2:
      var value = new legebill_type_workday_pb.Workday;
      reader.readMessage(value,legebill_type_workday_pb.Workday.deserializeBinaryFromReader);
      msg.addCustomWorkdays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomWorkdaysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      legebill_type_workday_pb.Workday.serializeBinaryToWriter
    );
  }
};


/**
 * optional string membership_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays} returns this
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated legebill.type.Workday custom_workdays = 2;
 * @return {!Array<!proto.legebill.type.Workday>}
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.prototype.getCustomWorkdaysList = function() {
  return /** @type{!Array<!proto.legebill.type.Workday>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_workday_pb.Workday, 2));
};


/**
 * @param {!Array<!proto.legebill.type.Workday>} value
 * @return {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays} returns this
*/
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.prototype.setCustomWorkdaysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.legebill.type.Workday=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Workday}
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.prototype.addCustomWorkdays = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.legebill.type.Workday, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.MemberCustomWorkdays} returns this
 */
proto.legebill.site.post_expectation.v4.MemberCustomWorkdays.prototype.clearCustomWorkdaysList = function() {
  return this.setCustomWorkdaysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.Leave.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.Leave} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.Leave.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    membershipId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    amount: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.Leave}
 */
proto.legebill.site.post_expectation.v4.Leave.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.Leave;
  return proto.legebill.site.post_expectation.v4.Leave.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.Leave} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.Leave}
 */
proto.legebill.site.post_expectation.v4.Leave.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 5:
      var value = /** @type {!proto.legebill.site.post_expectation.v4.LeaveAmount} */ (reader.readEnum());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.Leave.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.Leave} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.Leave.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.Leave} returns this
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string site_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.Leave} returns this
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string membership_id = 3;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.Leave} returns this
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.type.Date date = 4;
 * @return {?proto.google.type.Date}
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.Leave} returns this
*/
proto.legebill.site.post_expectation.v4.Leave.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.Leave} returns this
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.hasDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional LeaveAmount amount = 5;
 * @return {!proto.legebill.site.post_expectation.v4.LeaveAmount}
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.getAmount = function() {
  return /** @type {!proto.legebill.site.post_expectation.v4.LeaveAmount} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.LeaveAmount} value
 * @return {!proto.legebill.site.post_expectation.v4.Leave} returns this
 */
proto.legebill.site.post_expectation.v4.Leave.prototype.setAmount = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    membershipId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    startDate: (f = msg.getStartDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_type_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest;
  return proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string membership_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Date start_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} returns this
*/
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Date end_date = 4;
 * @return {?proto.google.type.Date}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} returns this
*/
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    memberExpectationsList: jspb.Message.toObjectList(msg.getMemberExpectationsList(),
    proto.legebill.site.post_expectation.v4.MemberExpectation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse;
  return proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.legebill.site.post_expectation.v4.MemberExpectation;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.MemberExpectation.deserializeBinaryFromReader);
      msg.addMemberExpectations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberExpectationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.legebill.site.post_expectation.v4.MemberExpectation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MemberExpectation member_expectations = 1;
 * @return {!Array<!proto.legebill.site.post_expectation.v4.MemberExpectation>}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.prototype.getMemberExpectationsList = function() {
  return /** @type{!Array<!proto.legebill.site.post_expectation.v4.MemberExpectation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.post_expectation.v4.MemberExpectation, 1));
};


/**
 * @param {!Array<!proto.legebill.site.post_expectation.v4.MemberExpectation>} value
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse} returns this
*/
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.prototype.setMemberExpectationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.MemberExpectation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.post_expectation.v4.MemberExpectation}
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.prototype.addMemberExpectations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.site.post_expectation.v4.MemberExpectation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse} returns this
 */
proto.legebill.site.post_expectation.v4.ListMemberExpectationsResponse.prototype.clearMemberExpectationsList = function() {
  return this.setMemberExpectationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.MemberExpectation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.MemberExpectation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.toObject = function(includeInstance, msg) {
  var f, obj = {
    membershipId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    postExpectationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dayExpectationsList: jspb.Message.toObjectList(msg.getDayExpectationsList(),
    proto.legebill.site.post_expectation.v4.DayExpectation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.MemberExpectation}
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.MemberExpectation;
  return proto.legebill.site.post_expectation.v4.MemberExpectation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.MemberExpectation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.MemberExpectation}
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostExpectationId(value);
      break;
    case 3:
      var value = new proto.legebill.site.post_expectation.v4.DayExpectation;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.DayExpectation.deserializeBinaryFromReader);
      msg.addDayExpectations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.MemberExpectation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.MemberExpectation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPostExpectationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDayExpectationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.legebill.site.post_expectation.v4.DayExpectation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string membership_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.MemberExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string post_expectation_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.getPostExpectationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.MemberExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.setPostExpectationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DayExpectation day_expectations = 3;
 * @return {!Array<!proto.legebill.site.post_expectation.v4.DayExpectation>}
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.getDayExpectationsList = function() {
  return /** @type{!Array<!proto.legebill.site.post_expectation.v4.DayExpectation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.post_expectation.v4.DayExpectation, 3));
};


/**
 * @param {!Array<!proto.legebill.site.post_expectation.v4.DayExpectation>} value
 * @return {!proto.legebill.site.post_expectation.v4.MemberExpectation} returns this
*/
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.setDayExpectationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.DayExpectation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.post_expectation.v4.DayExpectation}
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.addDayExpectations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.legebill.site.post_expectation.v4.DayExpectation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.MemberExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.MemberExpectation.prototype.clearDayExpectationsList = function() {
  return this.setDayExpectationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.DayExpectation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.DayExpectation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.DayExpectation.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    workHoursPts: jspb.Message.getFieldWithDefault(msg, 2, 0),
    includedLeave: jspb.Message.getFieldWithDefault(msg, 3, 0),
    leaveHoursPts: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.DayExpectation}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.DayExpectation;
  return proto.legebill.site.post_expectation.v4.DayExpectation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.DayExpectation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.DayExpectation}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWorkHoursPts(value);
      break;
    case 3:
      var value = /** @type {!proto.legebill.site.post_expectation.v4.LeaveAmount} */ (reader.readEnum());
      msg.setIncludedLeave(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLeaveHoursPts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.DayExpectation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.DayExpectation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.DayExpectation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getWorkHoursPts();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getIncludedLeave();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getLeaveHoursPts();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional google.type.Date date = 1;
 * @return {?proto.google.type.Date}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.DayExpectation} returns this
*/
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.DayExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 work_hours_pts = 2;
 * @return {number}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.getWorkHoursPts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.post_expectation.v4.DayExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.setWorkHoursPts = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional LeaveAmount included_leave = 3;
 * @return {!proto.legebill.site.post_expectation.v4.LeaveAmount}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.getIncludedLeave = function() {
  return /** @type {!proto.legebill.site.post_expectation.v4.LeaveAmount} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.LeaveAmount} value
 * @return {!proto.legebill.site.post_expectation.v4.DayExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.setIncludedLeave = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint32 leave_hours_pts = 4;
 * @return {number}
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.getLeaveHoursPts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.post_expectation.v4.DayExpectation} returns this
 */
proto.legebill.site.post_expectation.v4.DayExpectation.prototype.setLeaveHoursPts = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.CreateLeaveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    membershipId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    amount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.CreateLeaveRequest;
  return proto.legebill.site.post_expectation.v4.CreateLeaveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 4:
      var value = /** @type {!proto.legebill.site.post_expectation.v4.LeaveAmount} */ (reader.readEnum());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.CreateLeaveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest} returns this
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string membership_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest} returns this
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Date date = 3;
 * @return {?proto.google.type.Date}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest} returns this
*/
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest} returns this
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.hasDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional LeaveAmount amount = 4;
 * @return {!proto.legebill.site.post_expectation.v4.LeaveAmount}
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.getAmount = function() {
  return /** @type {!proto.legebill.site.post_expectation.v4.LeaveAmount} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.LeaveAmount} value
 * @return {!proto.legebill.site.post_expectation.v4.CreateLeaveRequest} returns this
 */
proto.legebill.site.post_expectation.v4.CreateLeaveRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ListLeavesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    membershipId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    startDate: (f = msg.getStartDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_type_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesRequest}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ListLeavesRequest;
  return proto.legebill.site.post_expectation.v4.ListLeavesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesRequest}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ListLeavesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string membership_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Date start_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} returns this
*/
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Date end_date = 4;
 * @return {?proto.google.type.Date}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} returns this
*/
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesRequest} returns this
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.post_expectation.v4.ListLeavesRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.ListLeavesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.ListLeavesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    leavesList: jspb.Message.toObjectList(msg.getLeavesList(),
    proto.legebill.site.post_expectation.v4.Leave.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesResponse}
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.ListLeavesResponse;
  return proto.legebill.site.post_expectation.v4.ListLeavesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.ListLeavesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesResponse}
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.legebill.site.post_expectation.v4.Leave;
      reader.readMessage(value,proto.legebill.site.post_expectation.v4.Leave.deserializeBinaryFromReader);
      msg.addLeaves(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.ListLeavesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.ListLeavesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeavesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.legebill.site.post_expectation.v4.Leave.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Leave leaves = 1;
 * @return {!Array<!proto.legebill.site.post_expectation.v4.Leave>}
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.prototype.getLeavesList = function() {
  return /** @type{!Array<!proto.legebill.site.post_expectation.v4.Leave>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.post_expectation.v4.Leave, 1));
};


/**
 * @param {!Array<!proto.legebill.site.post_expectation.v4.Leave>} value
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesResponse} returns this
*/
proto.legebill.site.post_expectation.v4.ListLeavesResponse.prototype.setLeavesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.Leave=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.post_expectation.v4.Leave}
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.prototype.addLeaves = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.site.post_expectation.v4.Leave, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.post_expectation.v4.ListLeavesResponse} returns this
 */
proto.legebill.site.post_expectation.v4.ListLeavesResponse.prototype.clearLeavesList = function() {
  return this.setLeavesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.DeleteLeaveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.DeleteLeaveRequest}
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.DeleteLeaveRequest;
  return proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.DeleteLeaveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.DeleteLeaveRequest}
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.DeleteLeaveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.DeleteLeaveRequest} returns this
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.DeleteLeaveRequest} returns this
 */
proto.legebill.site.post_expectation.v4.DeleteLeaveRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    postExpectationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    membershipId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest;
  return proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostExpectationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPostExpectationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string post_expectation_id = 1;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.prototype.getPostExpectationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest} returns this
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.prototype.setPostExpectationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string membership_id = 2;
 * @return {string}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest} returns this
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse;
  return proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus = {
  UNSUBSCRIBE_REMINDERS_UNSPECIFIED: 0,
  SUCCESS: 1
};

/**
 * optional UnsubscribeRemindersStatus status = 1;
 * @return {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus}
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.prototype.getStatus = function() {
  return /** @type {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus} value
 * @return {!proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse} returns this
 */
proto.legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.legebill.site.post_expectation.v4.LeaveAmount = {
  LEAVE_AMOUNT_UNSPECIFIED: 0,
  HALF_DAY: 1,
  FULL_DAY: 2
};

goog.object.extend(exports, proto.legebill.site.post_expectation.v4);
